export const CONFIG_ICON_COMPONENT = new Map([
  ['mj-raw', 'iframe'],
  ['mj-button', 'button'],
  ['mj-column', 'column'],
  ['mj-divider', 'divider'],
  ['mj-group', 'group'],
  ['mj-image', 'image'],
  ['mj-section', 'row'],
  ['mj-spacer', 'spacer'],
  ['mj-text', 'type'],
  ['mj-wrapper', 'wrapper'],
  ['fusion-bottom-menu', 'horizontalmenu'],
  ['fusion-button', 'button'],
  ['fusion-side-menu', 'verticalmenu'],
  ['fusion-slider', 'slider'],
  ['fusion-state-container', 'statecontainer'],
  ['fusion-column', 'column'],
  ['content-area', 'contentarea'],
  ['fusion-grid', ''],
  ['fusion-group', 'group'],
  ['fusion-inline-slideshow', 'slideshow'],
  ['fusion-line', 'line'],
  ['fusion-list', 'numberedlist'],
  ['fusion-sortable-list', 'numberedlist'],
  ['fusion-placeholder', 'placeholder'],
  ['fusion-section', 'row'],
  ['fusion-shape', 'shape'],
  ['fusion-slide-fragment', 'slidefragment'],
  ['fusion-tab-group', 'tabgroup'],
  ['fusion-text', 'type'],
  ['fusion-image', 'image'],
  ['fusion-video-player', 'video'],
  ['fusion-viewer', 'iframe'],
  ['fusion-popup', 'popup'],
  ['fusion-arrow-popup', 'popup'],
  ['fusion-references-popup', ''],
  ['fusion-table', 'table'],
  ['fusion-text-input', 'textinput'],
  ['inline-slideshow-indicators', ''],
  ['inline-slideshow-navigation', ''],
  ['inline-slideshow-state-container', 'statecontainer'],
  ['fusion-list-item', 'bulletpoint'],
  ['fusion-list', 'bulletpoint'],
  ['fusion-infotab', ''],
  ['fusion-audio-player', 'audio'],
  ['fusion-paint', ''],
  ['fusion-scroll', ''],
  ['fusion-submit-email', ''],
  ['fusion-zoom-container', ''],
]);
